'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: 'השירות אינו זמין כרגע, נסו שוב מאוחר יותר',
    NEED_ACTIVE: 'החשבון {{account}} שלכם משתמש באתר זה בפעם הראשונה. אנא {{activeLink}} כדי להשלים את ההפעלה וחזרו לעמוד זה כדי להמשיך בפעולה',
    GOTO_ACTIVE: 'הפעילו עכשיו',
    NOT_ACTIVED: 'החשבון לא הופעל בהצלחה, אנא {{activeLink}} כדי להשלים את ההפעלה',
    COMPLETE_ACTIVE: 'אשרו הפעלה',
    FORBID_ACTIVE: 'החשבון אינו נתמך ב-AliExpress!',
    SIGN_UP_WITH_ANOTHER_ACCOUNT: 'היכנסו עם חשבון אחר',
    ACTIVE_PAGE: 'בקרו בדף הפעלת החשבון'
};